import * as actions from './paymentActions';

const paymentReducers = {
  [actions.STORE_PAYMENT_DATA]: (state, { payload }) => ({
    ...state,
    ...payload,
  }),
  [actions.CLEAR_PAYMENT_DATA]: () => ({}),
  [actions.PAYMENT_SUBMITTED]: (state, { payload }) => {
    state.paymentResponse = payload;
    return state;
  },
};

export default {
  name: 'payment',
  reducers: paymentReducers,
};
